<template>
  <div>
        <div class="back">
      <img src="../assets/back.jpg" width="100%" height="100%" alt />
    </div>
    <div class="logo">
      <img src="../assets/logo22.png" alt class="logopic" />
    </div>
    <transition name="form-fade" mode="in-out">
      <section class="form_contianer">
        <div class="manage_tip">
          <p>智汇众盈传媒·用户注册</p>
        </div>
        <el-form>
          <el-form-item>
            <el-input v-model="username" placeholder="用户名(不支持中文,6个及其以上的数字或者英文)" clearable>
              <span></span>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input type="password" style="width:50%;float:left" v-model="password" placeholder="密码" clearable></el-input>
            <el-input type="password" style="width:50%;float:left" v-model="password2" placeholder="重输密码" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-input v-model="inviter" :disabled="hidden" placeholder="邀请人手机号（选填）" clearable></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-input v-model="phone" placeholder="手机号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="code" placeholder="验证码" clearable>
              <template slot="append">
                <el-button v-show="codeshow" @click="getCode">获取验证码</el-button>
                <el-button v-show="!codeshow">{{count}} s</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input style="width:50%;float:left" v-model="QQ" placeholder="QQ号" clearable></el-input>
            <el-input style="width:50%;float:left" v-model="weixin" placeholder="微信" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="radio">
              我已阅读并同意
              <a style="color:#fd5353" @click="XieYiShow=true">《智汇众盈传媒·用户注册协议》</a>
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="register" class="submit_btn">确定注册</el-button>
            <p class="register" @click="login">已有账号，登陆</p>
          </el-form-item>
        </el-form>
      </section>
    </transition>
    <input type="button" />
    <el-dialog title="智汇众盈传媒用户注册协议" :visible.sync="XieYiShow" width="50%">
      <pre>{{zcxy}}</pre>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      radio: true,
      username: "",
      XieYiShow: false,
      password: "",
      password2: "",
      phone: "",
      inviter:"",
      QQ: "",
      weixin: "",
      code: "",
      codeshow: true,
      count: "",
      timer: null,
      hidden:false,
      zcxy:`智汇众盈传媒用户注册协议
尊敬的用户，欢迎您注册成为本公司及本平台用户。本协议条款为用户与北京智汇众盈科技有限公司就智汇众盈传媒（http://pt.zhzymedia.cn/）平台使用相关事宜而签订，具有法律效力。在注册前请认真阅读本协议条款，如对本协议条款有异议则放弃成为本平台用户。如用户注册及有使用本平台的行为即表示用户已充分阅读、理解并接受智汇众盈传媒用户注册协议的全部内容，并自愿接受本协议各项条款的约束。
一：定义与声明
智汇众盈传媒平台为自主交易平台，上传所有资源、数据均为用户自主上传，用户必须完全同意本注册协议内容，才能能够享受本平台提供的服务。用户在本平台注册成功即表示用户完全接受本协议的全部条款。
二：用户资格
只有符合以下条件之一的自然人、法人或其他组织可以注册成为本平台用户，使用本平台提供的服务：
1、年满十八周岁且具有完全民事权利能力和民事行为能力的自然人；未满十八周岁的自然人需监护人（包括但不限于父母）经其书面同意；
2、根据中华人民共和国法律或其注册地法律、法规合法成立并有效存续的企业、事业单位、社团组织何其他组织。
3、无民事行为能力人、限制民事行为能力人及无经营资格的法人或其他组织不应注册成为本平台的用户或超过其民事权利或行为能力范围从事交易的，其与本平台协议自始无效。本平台一经发现，有权立即注销该用户，且有权追究其使用本平台服务时所造成的一切法律责任与一切损失。
4、用户必须填写真实的注册信息（包含但不限于：真实姓名、公司名称、联系方式。）。
三：用户权利和义务
1、用户有权根本协议及本平台网站相关规定，使用本平台提供的服务，包括但不限于用本平台发布任务信息、广告投放、参加本平台网站的活动及资讯信息等服务。
2、用户用于登录智汇众盈传媒平台（http://pt.zhzymedia.cn/）的用户名、密码等信息均为用户自行设置保管。用户在平台操作的任何行为（包括但不限于：账户密码、资源信息、收款人、报价等修改操作行为）均视为用户真实行为表现。用户应妥善保管用户名何密码，因用户名、密码泄露而导致的损失，均由用户自行承担；用户不得擅自专人或授权他人使用其在本平台网站的用户名或密码，如用户名或密码泄露造成的损失用户自行承担。
3、用户应保证所有注册信息及发布信息是真实准确的，包括但不限于：真实姓名、注册证号/身份证号码、公司信息、联系电话、支付宝账号、发布资源及信息等，并保证本公司及本平台可以通过上述联系方式及时与用户取得联系；如若信息有变，用户因及时更新，若因注册信息有误无法联系上用户而造成的损失由用户自行负责。
4、用户不得在本网站发布国家禁止发布、侵犯他人知识产权或其他合法权益的信息，也不得发布违背社会公共利益或公共道德的信息；
5、用户使用本网站时应当遵守诚实信用原则，不得采取不正当竞争行为，不得扰乱网上交易的正常秩序，不得从事与网上交易无关的行为；
6、用户在本平台交易中应当遵守诚实信用原则，不得以不正当竞争方式扰乱网上交易秩序，不得从事与网上交易无关的不当行为，不得在交易平台上发布任何违法信息。
7、用户应保证其身份及发布的推广内容符合《中国人民共和国广告法》等相关法律法规的规定，不得以虚假或引人误解的内容欺骗、误导消费者；
8、用户不得在本网站传播任何假冒伪劣产品或服务信息，包括但不限于假冒或仿冒他人专利、认证、商标的产品、不符合国家标准或行业标准的产品、过期变质产品、虚假服务等；
9、用户承诺自己在使用本平台实施的所有行为遵守国家法律、法规和本平台的相关规定以及各种社会公共利益或公共道德。对于任何法律后果，用户将独立承担所有法律责任。
10、用户应自行承担因使用本网站所产生的费用、税费，包括但不限于所得税、营业税、增值税、平台服务费等；
11、用户不得使用本平台或存在的漏洞进行非法牟利，否则本平台有权追究其由于使用漏洞给本平台造成的损失，并追究其法律责任。
12、用户不得使用以下方式登录本网站或破坏本网站提供的服务：
(1) 以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它自动方式访问或登录本网站；
(2) 通过任何方式对本网站内部结构造成或可能造成不合理或不合比例的重大负荷的行为；
(3) 通过任何方式干扰或试图干扰本网站的正常工作或本网站进行的任何活动。
13、用户不得实施以下作弊行为：
(1)通过人工及程序制造的无效点击提高流量，包括但不限于通过代理服务点击、互换点击等虚假无效点击；
(2)任何非正常的产品投放形式，任何以文字诱导或强制用户点击的行为；
(3)上传虚假截图。
14、用户应实时关注平台发布的用户须知、通知通告，并且仔细认真阅读我司发布的通知通告，如因未阅读通知通告造成的损失，用户自行承担。
15、用户同意本公司及本网站可在以下事项中使用用户的相关信息：
(1) 向用户及时发送重要通知，如软件更新、本协议条款的变更；
(2) 本公司及本网站进行审计、数据分析和研究等，以改进产品、服务及与用户之间的沟通；
(3) 依本协议约定，本公司及本网站管理、审查用户信息及进行处理措施；
(4) 本公司及本网站自行判断为合理使用的情形；
(5) 适用法律法规规定的其他事项。
16、用户同意接收来自本网站的信息，包括但不限于活动信息、交易信息、促销信息等；
四：本平台使用规范
1、禁止发布、传送、传播、储存违反国家法律法规禁止的内容；
2、禁止从事违反宪法规定的基本原则的活动！
3、禁止发布、传播危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一、损害国家荣誉和利益的信息及活动。
4、禁止散布谣言，扰乱社会秩序，破坏社会稳定、煽动民族仇恨、民族歧视，破坏民族团结、破坏国家宗教政策，宣扬邪教和封建迷信。
5、禁止发布、传播淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的任何相关信息活动。
6、禁止发布、传播、组织含有法律、行政法规禁止的其他内容的相关事宜。
一旦本平台发现用户发布以上违法内容，本平台有权时刻中止或删除活动，本平台有权利向公安、工商等相关政府机关举报，其后果由广告主自行承担。自用户发布违法内容起，视为用户违约，本平台相应的不再承担本《协议》下的义务。
若用户发布不实信息，由此带来不良后果，用户应承担相应责任，与本平台无关。如用户违反国家法律法规、本《协议》或对本平台进行恶意攻击时，本平台将有权停止向用户提供服务而不需承担任何责任，如导致本平台遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求,用户须向本平台赔偿相应的损失，包括但不限于诉讼费、律师费、其他第三方费用、业务影响损失等费用，并且用户需对其违反《协议》所产生的一切后果负全部法律责任。
五：本公司及本平台权利业务
1、本公司及本平台将在现有技术水平的基础上确保整个平台的正常运行，避免服务中断或将中断时间限制在最短时间内，保证用户网上交易活动的顺利进行。
2、本公司及本平台有义务对用户在注册使用本平台平台所遇到的问题及时作出解答。
3、本公司及本平台有权对用户的注册资料进行查阅，对存在任何问题或怀疑的注册资料，本平台有权发出通知询问用户并要求用户做出解释、改正，或不通知用户直接做出处罚、删除信息、删除账号等处理。
4、用户因在本平台上与其他用户产生纠纷的，用户同意本平台根据平台要求及了解的相关信息对纠纷进行判断、裁决，在判断过程中，本平台有权通过QQ、微信、电子邮件及电话联系向纠纷双方了解纠纷情况，并将根据了解的情况进行协调沟通，最终作出裁决。用户同意接受本平台裁决所导致的补款或扣款处理。若用户对纠纷还存在异议，本平台有权暂时冻结因纠纷所产生的费用，由双方自行通过法律法规解决后，本平台根据最终审判结果处理。需本平台提供相关资料，应向司法、行政部门求助，由司法、行政部门依照法定程序要求本平台提供相关资料。
5、因网上信息平台的特殊性，本公司及本平台不能对用户在本平台进行的所有行为进行审查。若本公司及本平台所掌握的情况认定用户在本平台的行为存在违法、违反本协议规定或其他不当行为的，本公司及本平台有权向用户核实有关情况，并根据具体情形采取向用户发出警告通知、删除用户相关信息、限制用户活动直至停止该用户提供服务等处理措施。
6、本公司及本平台发现用户有下列行为时，可根据情节轻重不通知用户直接采取限制账户、删除账户或其他限制性处理措施：发布虚假信息、借本平台规避费用、借本平台炒作、欺诈、与网上交易无关或不是以交易为目的、恶意竞价、扰乱或试图扰乱正常交易秩序、违反公共利益或其它损害或可能损害本公司、本平台或其他用户合法利益的行为。
六：充值协议
1、“账号余额”是本公司及平台向您提供的用于在本平台上进行相关消费的虚拟货币，您可以用“账号余额”自由购买本平台上各项产品或服务。但是，“账号余额”不能兑换为人民币，您应根据自己的实际需求进行充值。
2、本平台保留根据相关法律规定、主管部门要求、业务开展情况等因素对使用人民币充值“账号余额”的规则进行单方面变更、调整、中止或终止的权利。您同意无条件接受对上述购买规则的变更、调整、中止或终止，本平台开展前述行动时将以于本平台公布的方式通知，并自公布之日起自动生效，而无需另行单独通知您，也不就该等行动给您造成的任何损失承担任何责任。
3、在使用、充值、提现时，请您务必认真仔细确认自己的账号，并仔细选择相关操作选项。若因为您自身输入账号错误、操作不当或不了解充值计费方式等因素造成充错账号、错选充值种类等情形而损害自身权益的，本平台将不会作出任何补偿或赔偿。
4、若您以非法的方式，或使用非本平台所指定的充值方式进行充值，本平台不保证该充值顺利或者正确完成。若因此造成您权益受损，本平台不会作出任何补偿或赔偿，本平台同时保留随时终止您平台账号资格及使用各项充值服务的权利。
5、充值成功后，充值所增加的账号内“账号余额”可由您在本平台上自由使用，但本平台不会提供任何退还或逆向兑换服务。
6、如果本平台发现因系统故障或其他任何原因导致的处理错误，无论有利于本平台还是有利于您，本平台都有权在以电子邮件、短信或其他合理方式通知您后纠正该错误。如果该措施导致您实际收到的“账号余额”数量少于您应获得的“账号余额”，则本平台在确认该处理错误后会尽快将差额补足至您的账户中。如果该错误导致您实际收到的“账号余额”数量多于您应获得的“账号余额”，则无论错误的性质和原因如何，本平台有权从您的账户中直接扣除差额，如若用户余额不够的，本平台有权追回差额费用。
七：服务的中断与终止
1、本公司及本平台未向用户收取相关服务费用的情况下，可自行决定以包括但不限于本平台认为用户已违反本协议或用户超过90天内未登录本平台任何理由终止对用户的服务，并不再保存用户在本平台的全部资料而无需通知该用户（包括但不限于用户信息、商品信息、交易信息等）。服务终止后，本网站没有义务为用户保留其资料或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方；
2、用户向本网站提出注销用户身份的，本网站经审核同意后注销，本协议自注销之时起即终止，但本网站仍保留下列权利：
(1) 有权保留被注销用户的资料，包括但不限于用户注册信息、交易记录等；
(2) 如用户在注销前在本网站存在违法或违反本协议的行为，本网站仍可行使本协议所规定的权利。
3、用户如存在下列情况，本网站可通过注销用户账户的方式终止服务：
(1) 本公司及本网站根据所掌握的情况，认定用户存在违法、违反本协议相关规定或其它不当行为的；
(2) 用户注册信息及提供的资料有虚假内容的；
(3) 违反法律法规及本平台注册协议的。
(4) 本公司及本网站认为需终止服务的其它情况。
八：知识产权
1、用户上传、发布的所有信息内容知识版权均为用户所有（包括但不限于：文字、署名、图片、二维码），如因用户发布信息导致第三方合作方因知识版权问题而产生纠纷、赔偿的，将由用户赔偿。
2、本平台及本平台所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网站版面的安排、网页设计、经由本平台向用户呈现的广告或资讯，均由本平台或其它权利人依法享有相应的知识产权，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经本平台或权利人明示授权，用户保证不修改、出租、出借、出售、散布本平台及本平台所使用的上述任何资料和资源，或根据上述资料和资源制作成任何种类物品。
3、本平台授予用户不可转移及非专属的使用权，使用户可以通过计算机使用本平台的目标代码（以下简称软件），但用户不得且不得允许任何第三方，复制、修改、创作衍生作品、进行还原工程、反向组译，或以其它方式破译或试图破译源代码，或出售、转让软件或对软件进行再授权，或以其它方式移转软件之任何权利。用户同意不以任何方式修改软件，或使用修改后的软件。
4、用户不得经由非本平台所提供的界面使用本平台。
九：免责声明
当用户接受本协议时，用户应仔细阅读了解并同意以下条款∶
1. 用户使用本平台之风险由用户自行承担。本公司依据现有技术提供服务，尽管本公司将尽合理努力维护本网站的正常运行，但本公司无法随时预见到任何技术上的问题或其他困难，该等问题或困难可能导致用户的使用受到影响（包括但不限于交易延迟、交易失败等），请用户谨慎考虑使用本平台所提供服务可能带来的风险；
2. 本平台不保证以下事项：
(1) 本平台将符合用户的全部要求；
(2) 本平台在任何情况下能够不受干扰及时提供服务、安全可靠或免于出现故障或错误；
(3) 本平台交易服务所依据的数据来源和取得结果是正确或可靠的。
3. 是否经由本平台下载或取得任何资料，由用户自行考虑、衡量并且自负风险，因下载任何资料而导致用户电脑系统的任何损坏或资料流失，用户自行负责；
4. 用户经由本平台取得的建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证；
5. 基于以下原因而造成用户的利润、商誉或其它无形损失，本平台不承担任何直接或间接赔偿责任：
(1) 本平台的暂停使用或无法使用；
(2) 用户的资料遭到未获授权的存取或变更；
(3) 本平台中任何第三方之声明或行为。
6. 对于用户所发布任务、推广信息的合法性、真实性、品质以及用户履行交易的能力等，本平台无事先审查义务且不承担任何连带责任；若有任何第三方因用户发布的信息而向本公司及本平台主张权利，本公司及本平台将根据情况将用户信息告知第三方，由用户和第三方自行解决；若本公司及本平台因第三方主张权利而遭受任何损失，用户应负责赔偿；
7. 本平台提供与其它网站或资源的链接，用户可能会因此链接至其它运营商经营的网站，但不表示本平台与这些运营商有任何关系，本平台不对上述链接网站及其网页内容进行管理监督。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，本平台不负任何直接或间接赔偿责任；
8.本平台仅为用户提供交易平台，用户因使用本网站与任何第三方产生的纠纷均与本公司及本平台无关，本公司及本平台不承担任何责任。
十：不可抗力
因不可抗力或其他意外事件，超出本公司及本平台合理控制之外的原因、事件或其他因素导致的威能履行本协议下的任何义务不承担责任。包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。
十一：服务及协议声明
1、用户同意本公司及本平台根据市场情况以及本平台维护、服务费费率调整、更改相应的对外报价。
2、本协议可由本公司及本平台随时根据法律法规、公司规划调整而更改更新协议内容，更新后的协议条款一旦公布即代替原来的协议条款，本平台不在另行通知，用户可在本平台自行查阅最新版协议条款。在本平台修改协议条款后，如果用户不接受修改后的条款，可立即停止使用本平台提供的服务，用户继续使用本平台提供的服务将被视为接受修改后的协议。
十二：争议解决方式
1、本《协议》及其修订本的有效性、履行和与本《协议》及其修订本效力有关的所有事宜，将受中华人民共和国法律管辖，任何争议仅适用中华人民共和国法律。
2、因使用本平台服务所引起与本平台的任何争议，均应提交深圳市法院进行仲裁裁决。相关争议应单独仲裁，不得与任何其它方的争议在任何仲裁中合并处理。该仲裁裁决是终局，对各方均有约束力。如果所涉及的争议不适于仲裁解决，用户同意一切争议由本平台所在地有管辖权的法院管辖。`
    };
  },
  created() {
    if( this.$route.query&&this.$route.query.intuser){
      this.inviter=this.$route.query.intuser
      this.hidden=true
    }
  },
  watch: {
    username: function() {
      this.username = this.username.replace(/[\W]/g, "");
    }
  },
  methods: {
    register() {
      console.log(this.password);

      if (this.username.length<6) {
        this.$notify.error({
          title: "提示",
          message: "用户名设置最少要求6个及其以上的数字或者英文。",
          offset: 100
        });
        return;
      }
      if (this.code == "" || this.phone == "") {
        this.$notify.error({
          title: "错误",
          message: "请填写手机号与验证码",
          offset: 100
        });
        return;
      }
      // 
      if (this.password == this.password2 && this.password != "") {
        axios
          .post(
            `http://pt.zhzymedia.cn/api/client_login/Register/v1?username=${this.username}&password=${this.password}&phone=${this.phone}&QQ=${this.QQ}&weixin=${this.weixin}&code=${this.code}&inviter=${this.inviter}`
            // `http://pt.zhzymedia.cn/api/client_login/Register/v1?username=${this.username}&password=${this.password}&phone=${this.phone}&QQ=${this.QQ}&weixin=${this.weixin}&code=${this.code}&inviter=${this.inviter}`
          )
          .then(res => {
            console.log(res.data);
            if (res.data.code == 0) {
              // localStorage.setItem("token", res.data.data.token);
              this.$notify({
                title: "成功",
                message: "注册成功",
                type: "success"
              });
              this.$router.replace("/");
            } else {
              this.$notify.error({
                title: "错误",
                message: res.data.message,
                offset: 100
              });
              return false;
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.$notify.error({
          title: "错误",
          message: "两次密码输入不一致",
          offset: 100
        });
        return false;
      }
    },
    getCode() {
      var that = this;
      axios
        .get(
          `http://pt.zhzymedia.cn/api/client_login/GetSmsCode/v1?phone=${this.phone}`
          // `http://pt.zhzymedia.cn/api/client_login/GetSmsCode/v1?phone=${this.phone}`
        )
        .then(res => {
          if (res.data.code == 0) {
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.codeshow = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.codeshow = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: res.data.message,
              offset: 100
            });
          }
        })
        .catch(function(error) {});
      const TIME_COUNT = 59;
    },
    login() {
      this.$router.replace("/");
    }
  }
};
</script>
<style lang="less" scoped>
@import "../style/mixin";
.back{
    width:100%;  
    height:100%;  
    z-index:-1;
    position: absolute;
}
.logopic {
  width: 206px;
  /* height: 162px; */
}
.logo{
     position: absolute;
     left: 139px;
}
.register {
  margin-top: 5px;
  font-size: 12pt;
  cursor: pointer;
}
.login_page {
  background-color: #324057;
}
.manage_tip {
  position: absolute;
  width: 100%;
  top: -100px;
  left: 0;
  p {
    font-size: 34px;
    color: #fff;
  }
}
.form_contianer {
  .wh(340px, 510px);
  .ctp(340px, 260px);
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  background-color: #fff;
  top: 40%;
  .submit_btn {
    width: 100%;
    font-size: 16px;
  }
}
.tip {
  font-size: 12px;
  color: red;
}
.form-fade-enter-active,
.form-fade-leave-active {
  transition: all 1s;
}
.form-fade-enter,
.form-fade-leave-active {
  transform: translate3d(0, -50px, 0);
  opacity: 0;
}
.xieyi_title {
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>